/**
 * Avatar resolution helpers
 *
 * The API computes the canonical photo server-side (BL-009) — when
 * `profile.photo` is present its `url` IS the answer. The chain below it
 * exists only for responses that predate the contract:
 * 1) profile.photo.url (canonical — server-resolved upload-or-LinkedIn)
 * 2) talent.customFields.avatarUrl (legacy onboarding upload)
 * 3) profile.avatarUrl (top-level API field from /users/me)
 * 4) profile.imageUrl (legacy compatibility)
 * 5) authImageUrl (Clerk session fallback)
 */

interface ProfileLike {
  avatarUrl?: string | null;
  imageUrl?: string | null;
  photo?: { url: string | null } | null;
  talent?: {
    customFields?: Record<string, unknown> | null;
  } | null;
}

function asNonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim().length > 0 ? value : undefined;
}

export function resolveProfileAvatarUrl(
  profile?: ProfileLike | null,
  authImageUrl?: string | null
): string | undefined {
  const canonical = asNonEmptyString(profile?.photo?.url);
  const customFields = profile?.talent?.customFields ?? undefined;
  const customAvatar = asNonEmptyString(customFields?.avatarUrl);
  const profileAvatar = asNonEmptyString(profile?.avatarUrl);
  const profileImage = asNonEmptyString(profile?.imageUrl);
  const authImage = asNonEmptyString(authImageUrl);

  return canonical || customAvatar || profileAvatar || profileImage || authImage;
}
